module.exports = __webpack_public_path__ + "static/media/inc-drill.6bd59af8.svg";